import Api from './api.service';

export default {
  login: (data) => Api.post('auth/admin-login', data),
  refresh: () => Api.get('auth/refresh'),
};
